import { LayoutCanvas } from '../../types/types';
import { LAYOUT_FIXED_CANVAS_PADDING } from '../../constants';
import { getLayoutFixedCellSize } from './getLayoutFixedCellSize';

// Logical canvas size of the fixed grid — the extent of all cells including
// the gaps between them, plus the outer padding (the selection border of the
// edge buttons must not clip on the stage bounds — QA-279). bestOfScale then
// fits it into the workspace.
export const getLayoutFixedGridSize = (
  canvas: LayoutCanvas,
  objectCount: number
): { width: number; height: number } => {
  const count = Math.max(1, objectCount);
  const { width: cellWidth, height: cellHeight } =
    getLayoutFixedCellSize(canvas);
  const gapX = canvas.gapX ?? 0;
  const gapY = canvas.gapY ?? 0;
  const hasColumns = !!canvas.columns && canvas.columns > 0;
  const hasRows = !!canvas.rows && canvas.rows > 0;

  let columnCount: number;
  let rowCount: number;

  if (hasRows && !hasColumns) {
    rowCount = canvas.rows as number;
    columnCount = Math.max(1, Math.ceil(count / rowCount));
  } else {
    columnCount = hasColumns ? (canvas.columns as number) : 1;
    rowCount = Math.max(1, Math.ceil(count / columnCount));
  }

  return {
    width:
      columnCount * (cellWidth + gapX) - gapX + 2 * LAYOUT_FIXED_CANVAS_PADDING,
    height:
      rowCount * (cellHeight + gapY) - gapY + 2 * LAYOUT_FIXED_CANVAS_PADDING,
  };
};
